// extracted by mini-css-extract-plugin
export default {"root":"p8EOIpX8","fontSize14":"nDnQxbWl","fontSize16":"p7yQleOP"};